import React, { useEffect } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import * as Metrics from './utils/trackMetric';
import * as MetricEvents from '../../constants/metrics';

export const ApplePayButton = ({ renderMode, category, initPage, productId, ...props }) => {
  useEffect(() => {
    if (initPage === 'product_detail') {
      Metrics.track(MetricEvents.PDP_APPLE_PAY_BUTTON_IMPRESSION);
    } else {
      Metrics.track(MetricEvents.CART_APPLE_PAY_BUTTON_IMPRESSION);
    }
  }, [initPage]);

  const { Block } = UX2.Element;
  const styles = {
    outer: {
      display: 'flex',
      position: 'relative',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '0',
      backgroundRepeat: 'no-repeat',
      borderRadius: 'medium',
      border: '0',
      backgroundColor: category !== 'neutral' ? '!white' : '!black',
      paddingTop: 'small',
      paddingBottom: 'small',
      lineHeight: '18px',
      minWidth: '120px',
      cursor: renderMode === 'PUBLISH' ? 'pointer' : 'not-allowed'
    },
    inner: {
      position: 'relative',
      backgroundSize: '100% 100%',
      backgroundOrigin: 'content-box',
      backgroundImage:
        category !== 'neutral'
          ? '!-webkit-named-image(apple-pay-logo-black)'
          : '!-webkit-named-image(apple-pay-logo-white)',
      minWidth: '40px',
      minHeight: '18px',
      marginVertical: '0',
      marginHorizontal: 'auto'
    }
  };

  return (
    <Block tag='button' id={ `apple-pay-btn-${productId}` } style={ styles.outer } { ...props }>
      <Block style={ styles.inner } />
    </Block>
  );
};

ApplePayButton.propTypes = {
  renderMode: PropTypes.string,
  category: PropTypes.string,
  initPage: PropTypes.string,
  productId: PropTypes.string
};
